import { Component, ViewChild } from '@angular/core';
import { ShipListingComponent } from './ship-listing/ship-listing.component';

@Component({
  selector: 'app-ship',
  templateUrl: './ship.component.html',
  styleUrls: ['./ship.component.scss']
})
export class ShipComponent {

  @ViewChild('shipListing') shipListingComponent!: ShipListingComponent;

  onShipAdded(): void {
    console.log('Ship added successfully');
    // Trigger refresh of the ship listing
    if (this.shipListingComponent) {
      this.shipListingComponent.onShipAdded();
    }
  }

  onShipUpdated(): void {
    console.log('Ship updated successfully');
    // Trigger refresh of the ship listing
    if (this.shipListingComponent) {
      this.shipListingComponent.onShipUpdated();
    }
  }
}
